var _rect, _g, _rect2, _rect3, _rect4, _g2, _rect5, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTemplate1Focus2Left(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 98,
    viewBox: "0 0 196 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 196,
    height: 98,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 15,
    width: 81,
    height: 67,
    rx: 5,
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.129 39.5455V57H139.487V42.1875H139.385L135.209 44.9148V42.392L139.564 39.5455H142.129Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 15,
    width: 81,
    height: 67,
    rx: 5,
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 82,
    width: 32,
    height: 79,
    rx: 5,
    transform: "rotate(-90 16 82)",
    fill: "#007FFF",
    fillOpacity: 0.3
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 82,
    width: 32,
    height: 79,
    rx: 5,
    transform: "rotate(-90 16 82)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_146)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 31,
    height: 79,
    rx: 5,
    transform: "rotate(-90 16 46)",
    fill: "#007FFF",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.8196 39V37.0909L55.7259 30.9716C56.3565 30.3068 56.8764 29.7244 57.2855 29.2244C57.7003 28.7187 58.0099 28.2386 58.2145 27.7841C58.419 27.3295 58.5213 26.8466 58.5213 26.3352C58.5213 25.7557 58.3849 25.2557 58.1122 24.8352C57.8395 24.4091 57.4673 24.0824 56.9957 23.8551C56.5241 23.6222 55.9929 23.5057 55.402 23.5057C54.777 23.5057 54.2315 23.6335 53.7656 23.8892C53.2997 24.1449 52.9418 24.5057 52.6918 24.9716C52.4418 25.4375 52.3168 25.983 52.3168 26.608H49.8026C49.8026 25.5455 50.0469 24.6165 50.5355 23.821C51.0241 23.0256 51.6946 22.4091 52.5469 21.9716C53.3991 21.5284 54.3679 21.3068 55.4531 21.3068C56.5497 21.3068 57.5156 21.5256 58.3509 21.9631C59.1918 22.3949 59.848 22.9858 60.3196 23.7358C60.7912 24.4801 61.027 25.321 61.027 26.2585C61.027 26.9062 60.9048 27.5398 60.6605 28.1591C60.4219 28.7784 60.0043 29.4687 59.4077 30.2301C58.8111 30.9858 57.9815 31.9034 56.919 32.983L53.4503 36.6136V36.7415H61.3082V39H49.8196Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  }))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 31,
    height: 79,
    rx: 5,
    transform: "rotate(-90 16 46)",
    stroke: "#007FFF",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.5213 75.2386C54.3509 75.2386 53.3054 75.0369 52.3849 74.6335C51.4702 74.2301 50.7457 73.6705 50.2116 72.9545C49.6832 72.233 49.3991 71.3977 49.3594 70.4489H52.0355C52.0696 70.9659 52.2429 71.4148 52.5554 71.7955C52.8736 72.1705 53.2884 72.4602 53.7997 72.6648C54.3111 72.8693 54.8793 72.9716 55.5043 72.9716C56.1918 72.9716 56.7997 72.8523 57.3281 72.6136C57.8622 72.375 58.2798 72.0426 58.581 71.6165C58.8821 71.1847 59.0327 70.6875 59.0327 70.125C59.0327 69.5398 58.8821 69.0256 58.581 68.5824C58.2855 68.1335 57.8509 67.7812 57.277 67.5256C56.7088 67.2699 56.0213 67.142 55.2145 67.142H53.7401V64.9943H55.2145C55.8622 64.9943 56.4304 64.8778 56.919 64.6449C57.4134 64.4119 57.7997 64.0881 58.0781 63.6733C58.3565 63.2528 58.4957 62.7614 58.4957 62.1989C58.4957 61.6591 58.3736 61.1903 58.1293 60.7926C57.8906 60.3892 57.5497 60.0739 57.1065 59.8466C56.669 59.6193 56.152 59.5057 55.5554 59.5057C54.9872 59.5057 54.456 59.6108 53.9616 59.821C53.473 60.0256 53.0753 60.321 52.7685 60.7074C52.4616 61.0881 52.2969 61.5455 52.2741 62.0795H49.7259C49.7543 61.1364 50.0327 60.3068 50.5611 59.5909C51.0952 58.875 51.7997 58.3153 52.6747 57.9119C53.5497 57.5085 54.5213 57.3068 55.5895 57.3068C56.7088 57.3068 57.6747 57.5256 58.4872 57.9631C59.3054 58.3949 59.9361 58.9716 60.3793 59.6932C60.8281 60.4148 61.0497 61.2045 61.044 62.0625C61.0497 63.0398 60.777 63.8693 60.2259 64.5511C59.6804 65.233 58.9531 65.6903 58.044 65.9233V66.0597C59.2031 66.2358 60.1009 66.696 60.7372 67.4403C61.3793 68.1847 61.6974 69.108 61.6918 70.2102C61.6974 71.1705 61.4304 72.0312 60.8906 72.7926C60.3565 73.554 59.6264 74.1534 58.7003 74.5909C57.7741 75.0227 56.7145 75.2386 55.5213 75.2386Z",
    fill: "#007FFF",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_146"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 99,
    y: 15,
    width: 81,
    height: 67,
    rx: 5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_146"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 46,
    width: 31,
    height: 79,
    rx: 5,
    transform: "rotate(-90 16 46)",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemplate1Focus2Left);
export default __webpack_public_path__ + "static/media/template_1focus_2left.f69e00e81afcf05dd81bd2d4f84422fd.svg";
export { ForwardRef as ReactComponent };